<div class="banner-adv-bg" [ngClass]="closeBanner ? 'd-none':''">
    <div id="banner-adv" class="banner-adv">
        <div class="flex-adv">
            <a href="https://themeforest.net/item/costic-food-dashboard-template/27823635" target="_blank">
                <i class="fas fa-gift"></i>
                <span class="text">Get FREE CRM Dashboard with Quickmunch.</span>
            </a>
            <a href="https://themeforest.net/item/costic-food-dashboard-template/27823635" target="_blank"
                class="btn-second btn-submit">View Dashboard here</a>
        </div>
        <span class="close-banner" (click)="toggleBanner()"></span>
    </div>
</div>
